import * as React from 'react';

export default function TagOutdoor({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 25 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.90039 10.9988C5.72882 10.9988 6.40039 10.3272 6.40039 9.49881C6.40039 8.67038 5.72882 7.99881 4.90039 7.99881C4.07196 7.99881 3.40039 8.67038 3.40039 9.49881C3.40039 10.3272 4.07196 10.9988 4.90039 10.9988Z"
        fill="currentColor"
      />
      <path
        d="M22.5704 9.16881C22.5704 5.25881 19.3804 2.10881 15.4604 2.16881C11.6304 2.22881 8.47039 5.53881 8.58039 9.35881C8.67039 12.7388 11.1604 15.5188 14.4104 16.0588V19.9988H6.40039V16.9988H6.90039C7.18039 16.9988 7.40039 16.7788 7.40039 16.4988V12.9988C7.40039 12.4488 6.95039 11.9988 6.40039 11.9988H3.40039C2.85039 11.9988 2.40039 12.4488 2.40039 12.9988V16.4988C2.40039 16.7788 2.62039 16.9988 2.90039 16.9988H3.40039V20.9988C3.40039 21.5488 3.85039 21.9988 4.40039 21.9988H18.4004C18.9504 21.9988 19.4004 21.5488 19.4004 20.9988C19.4004 20.4488 18.9504 19.9988 18.4004 19.9988H16.4004V16.1188C19.8704 15.7088 22.5704 12.7588 22.5704 9.16881Z"
        fill="currentColor"
      />
    </svg>
  );
}
